// extracted by mini-css-extract-plugin
module.exports = {"close":"Close_close__2Yovv","close__button":"Close_close__button__1Pget","close__cross":"Close_close__cross__33Jtr","close__bg":"Close_close__bg__20QP0"};